import { render, staticRenderFns } from "./ChatRegistration.vue?vue&type=template&id=36150bc8"
import script from "./ChatRegistration.vue?vue&type=script&lang=js"
export * from "./ChatRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports